import React, { useState, useRef, useEffect } from 'react'
import { Overlay, Popover, Badge, Row, Col } from 'react-bootstrap'

const StripeIDsFormatter = ({ row, scrollContainerRef }) => {
    const [show, setShow] = useState(false)
    const targetRef = useRef(null)

    useEffect(() => {
        if (!show) return
        const container = scrollContainerRef.current
        if (!container) return

        const handleScroll = () => setShow(false)
        container.addEventListener('scroll', handleScroll, { capture: true })

        return () => {
            container.removeEventListener('scroll', handleScroll, { capture: true })
        }
    }, [show, scrollContainerRef])

    return (
        <>
            <Badge
                ref={targetRef}
                onClick={() => setShow(v => !v)}
                className="proposalBadge font12"
                style={{ cursor: 'pointer' }}
            >
                {row.source && row.stripe_id ? 2 : 1}
            </Badge>

            <Overlay
                show={show}
                target={targetRef.current}
                placement="left"
                rootClose
                onHide={() => setShow(false)}
            >
                <Popover id={`popover-${row.id}`}>
                    {row.stripe_id && (
                        <Row>
                            <Col xs={12}>Stripe ID:</Col>
                            <Col xs={12} className="bold">{row.stripe_id}</Col>
                        </Row>
                    )}
                    {row.source && (
                        <Row>
                            <Col xs={12}>Source ID:</Col>
                            <Col xs={12} className="bold">{row.source}</Col>
                        </Row>
                    )}
                </Popover>
            </Overlay>
        </>
    )
}

export default StripeIDsFormatter
